function SocialMedia() {
  return (
    <div className="mediaBox">
      <div className="gridBox1">
        <div className="box1"></div>
        <div className="box2"></div>
        <div className="box3"></div>
        <div className="box4"></div>
      </div>
      <div className="gridBox2">
        <p>@skynlodge</p>
        <h1 className="notified">Get notified about our new products</h1>
        <a href="https://www.instagram.com/skynlodge/" class="button">
          Follow Us
        </a>
      </div>
      <div className="gridBox3">
        <div className="box5"></div>
        <div className="box6"></div>
        <div className="box7"></div>
        <div className="box8"></div>
      </div>
    </div>
  );
}

export default SocialMedia;
